import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { colors } from './styles/colors';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import ManageContent from './components/ManageContent';
import Download from './components/Download';
import Footer from './components/Footer';
import Contact from './components/Contact';
import './App.css';

const theme = createTheme({
    palette: {
        primary: {
            main: colors.primary.main,
            light: colors.primary.light,
            dark: colors.primary.dark,
        },
        secondary: {
            main: colors.secondary.main,
            light: colors.secondary.light,
            dark: colors.secondary.dark,
        },
        background: {
            default: colors.background.secondary,
            paper: colors.background.primary,
        },
        text: {
            primary: colors.text.primary,
            secondary: colors.text.secondary,
        }
    },
    typography: {
        fontFamily: '"Poppins", sans-serif',
        h1: {
            fontWeight: 700,
        },
        h2: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 12,
    },
    shadows: [
        'none',
        `0 2px 4px ${colors.shadow.primary}`,
        `0 4px 8px ${colors.shadow.primary}`,
        `0 8px 16px ${colors.shadow.primary}`,
        // ... resto de las sombras
    ],
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <ParallaxProvider>
                <div className="App">
                    <Navbar />
                    <section id="hero">
                        <Hero />
                    </section>
                    <section id="about">
                        <About />
                    </section>
                    <section id="features">
                        <Features />
                    </section>
                    <section id="gallery">
                        <Gallery />
                    </section>
                    <section id="testimonials">
                        <Testimonials />
                    </section>
                    <section id="manage-content">
                        <ManageContent />
                    </section>
                    <section id="download">
                        <Download />
                    </section>
                    <section id="contact">
                        <Contact />
                    </section>
                    <Footer />
                </div>
            </ParallaxProvider>
        </ThemeProvider>
    );
}

export default App; 